var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40234 4.75L8.21875 1.96094L8.79297 1.38672C8.875 1.30469 8.875 1.16797 8.79297 1.05859L8.19141 0.457031C8.08203 0.375 7.94531 0.375 7.86328 0.457031L4.5 3.84766L1.10938 0.457031C1.02734 0.375 0.890625 0.375 0.78125 0.457031L0.179688 1.05859C0.0976562 1.16797 0.0976562 1.30469 0.179688 1.38672L3.57031 4.75L0.179688 8.14062C0.0976562 8.22266 0.0976562 8.35938 0.179688 8.46875L0.78125 9.07031C0.890625 9.15234 1.02734 9.15234 1.10938 9.07031L4.5 5.67969L7.28906 8.49609L7.86328 9.07031C7.94531 9.15234 8.08203 9.15234 8.19141 9.07031L8.79297 8.46875C8.875 8.35938 8.875 8.22266 8.79297 8.14062L5.40234 4.75Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.7327cc648fec33c560552ce865603888.svg";
export { ForwardRef as ReactComponent };